const URL = {
  "avt-vms.com": "https://apis.avt-vms.com/api/",
  "www.avt-vms.com": "https://apis.avt-vms.com/api/",
  default: "https://apis-dev.avt-vms.com/api/",
};

const BaseUrl = URL[window.location.hostname] || URL.default;

module.exports = {
  BaseUrl,
};